export default class ComparisonHelper {
    // {{#ifEquals var1 var2}}content{{/ifEquals}}
    static ifEquals(arg1, arg2, options) {
        /* eslint-disable-next-line eqeqeq */
        return arg1 == arg2 ? options.fn(this) : options.inverse(this);
    }
}
